import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationStore } from './authentication.store';

@Injectable()
export class AuthGuard {
    constructor(
        private router: Router,
        private authenticationStore: AuthenticationStore,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        let requiredAuthorities: string[] = route.data.authorities;
        const allRequiredAuthorities: string[] = route.data.allAuthorities;
        return this.authenticationStore.getCurrentUser().pipe(
            map((currentUser) => {
                if (!currentUser) {
                    this.router.navigate(['/login'], { queryParams: { linkUrl: state.url } });
                    return false;
                }
                const hasNoRestriction =
                    (!requiredAuthorities || requiredAuthorities.length === 0) && (!allRequiredAuthorities || allRequiredAuthorities.length === 0);
                if (hasNoRestriction) {
                    return true;
                }
                if (!Array.isArray(requiredAuthorities)) {
                    requiredAuthorities = [requiredAuthorities];
                }
                const hasAny = requiredAuthorities?.some((authority) => currentUser.authorities.includes(authority)) ?? false;
                const hasAll = allRequiredAuthorities?.every((authority) => currentUser.authorities.includes(authority)) ?? false;
                if (hasAny || hasAll) {
                    return true;
                }
                if (isDevMode()) {
                    console.error('User has not any of required authorities: ', requiredAuthorities, allRequiredAuthorities);
                }
                this.router.navigate(['/access-denied']);
                return false;
            }),
        );
    }
}
